export default {
    state: {
        config: {}
    },
    getters: {
        config: state => {
            return state.config;
        }
    },
    mutations: {
        configUpdate (state, config) {
            state.config = config || {};
        }
    }
};